import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { Button, Card, Cell, DialogContainer, ExpansionList, ExpansionPanel, Grid, TableColumn, TableRow } from 'react-md';
import MultiSelectReact from 'react-multi-select-ext';
import {
    NotificationContainer,
    NotificationManager
} from 'react-notifications';
import { browserHistory } from 'react-router';
import Toggle from 'react-toggle';
import ApiRequestService from '../component/ApiRequestService';
import Loader from '../component/Loader';
import Properties from '../component/Properties';
import SelectBox from '../component/SelectBox';
import instructorStyles from '../css/instructorStyles.css.js';
import '../css/QuizCreationStyle.css';
import styles from '../css/styles.css.js';
import crossIcon from '../images/png/crossIcon.png';
import { AppProperties } from '../common/function';







const sectionListMap = function (mapping_data)
{
    var condensedList = {};
    if(mapping_data && mapping_data.length > 0)
    {
        mapping_data.forEach(element => {
            if(condensedList[element.course_id] === undefined || condensedList[element.course_id] === null)
                {
                    let sectionName = element.section_name;
                    if(element.section_name !==''){

                    condensedList[element.course_id] = element;

                    condensedList[element.course_id].section_name = [];
                    condensedList[element.course_id].section_name.push(sectionName);
                    let id = element.id;
                    condensedList[element.course_id].id = [];
                    condensedList[element.course_id].id.push(id)
                  }
                }
                else
                {
                    let sectionName = element.section_name;
                    if(element.section_name !==''){

                    condensedList[element.course_id].section_name.push(sectionName);
                    condensedList[element.course_id].id.push(element.id);
                  }
                }
        });
    }

    var condensedArray = Object.keys(condensedList).map(function (key) { return condensedList[key]; });
    return condensedArray;

}

export default class ICSMappings extends Component {

    appProperties = AppProperties();

    constructor(props){
        super(props);
        this.state = {
          instructor_id: this.props.location.query.instructor_id,
          instructor_name:this.props.location.query.instructor_name,
          instructor_first_name:this.props.location.query.instructor_first_name,
          instructor_last_name:this.props.location.query.instructor_last_name,
          icsmappings: [],
          istmappings: [],
          istCondensedArray: [],
          courses: [],
          sections: [],
          subjects: [],
          insertCourse: '',
          insertSubject: '',
          insertSection: [],
          visible: false,
          addMode : true,
          condensedArray: [],
          page_loading: false,
          dialog_loading: false,
          disabled: true,
          visibleSubject: false,
          subjectHide:false,
          instructorHmAccess : 0,
          instructorLoginAttemptPage : 0,
        };
        console.log("TEST: ",this.props)
        this.selectBoxCourseHandleChange =  this.selectBoxCourseHandleChange.bind(this);
        this.selectBoxSubjectHandleChange =  this.selectBoxSubjectHandleChange.bind(this);
        this.deleteMapping = this.deleteMapping.bind(this);
        this.deleteSubjectMapping = this.deleteSubjectMapping.bind(this);        
        this.addMapping = this.addMapping.bind(this);
        this.addSubject = this.addSubject.bind(this);
        this.updateInstructor = this.updateInstructor.bind(this);
        

    }

    componentWillUpdate()
    {
      console.log("componentWillUpdate");
        this.addBreadCrumbs();
    }

    addBreadCrumbs = () =>
    {
      console.log("Sections AddBreadCrumbs");
      this.props.replaceBreadCrumb([
        {
            "name":"Settings",
            "type":"",
            "onclickPath":"SettingsPage"
        },
        {
            "name":"All Instructors",
            "type":"",
            "onclickPath":"instructors"
          },
          {
            "name":this.state.instructor_name,
            "type":"Instructor",
            "onclickPath":'ICSMappings?instructor_id='+this.state.instructor_id
                          +'&instructor_name='+this.state.instructor_name
          }
        ]);
    }

    prepareData(){
        this.setState({page_loading:true});
        var inst_id =parseInt(this.state.instructor_id,10);
        const payload = {
            instructor_id: inst_id

        }
        ApiRequestService({
            method: 'post',
            url: '/getAllICSMapping',
            data: payload

        })
        .then(res => {
            console.log(this.state.istmappings);
            var condensedArray = sectionListMap(res.data.data.icsmapping_names);
            console.log(res.data.data,"condensedArray",condensedArray)
            this.setState({
                icsmappings: res.data.data.icsmapping_names,
                condensedArray: condensedArray,
                page_loading : false
            });
        })
    }

    getSubjectData(){
        console.debug("state of course and subject ",this.state.courses,this.state.subjects)
       // this.setState({page_loading:true});
        var inst_id =parseInt(this.state.instructor_id,10);
        const payload = {
            instructor_id: inst_id

        }
        ApiRequestService({
            method: 'post',
            url: '/getAllISTMapping',
            data: payload

        })
        .then(res => {
            this.setState({
                istmappings: res.data.data.istmapping_names
               // page_loading : false
            });
        })
    }

    componentWillMount(){
        this.getAccessRights();
        this.getSubjectData();
        this.prepareData();
        
    }
    getAccessRights = () =>{
        const payload = {
          instructor_name: this.state.instructor_name
        };
        ApiRequestService({
          method: 'post',
          url: '/getHmAccess',
          data: payload
        }).then(res => {
          if (res.data.data !== null && res.data.data !== undefined) {
           // console.debug("res.data.data.instructor_hm_access ",res.data.data.instructor_hm_access)
              this.setState({
                instructorHmAccess : res.data.data.instructor_hm_access,
                instructorLoginAttemptPage : res.data.data.instructor_login_attempt_access
              })
           
          }
        })
      }

    addMappingService(props){
        console.debug("state of course and subject ",this.state.courses,this.state.subjects)
        this.errorMessageHide();
         console.debug(props)
        ApiRequestService({
            method: 'post',
            url:  '/addICSMapping',
            data: props

        }).then(res => {
            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
                    NotificationManager.error("Duplicate entry. Section already associated with Instructor", 'Error Message', 5000);
                }else{
                    NotificationManager.error(res.data.message, 'Error Message', 5000);
                }
            } else {
                NotificationManager.success('Section(s) Added', 'Success');
            }
            this.prepareData();
            this.hide();
        });
    }

    addMapping(){
        this.errorMessageHide();
        console.log("Add Mapping :" + this.state.insertSection);
        var inst_id =parseInt(this.state.instructor_id,10);
        console.debug(this.state.instructor_id,inst_id)
        if(this.state.insertCourse ===undefined || this.state.insertCourse ===''){
            this.setState({disabled:true});
            return;
        }
        else if(this.state.insertSection === undefined || this.state.insertSection.length === 0)
        {
            this.setState({page_loading:true});
            const payload = {
                instructor_id: inst_id,
                course_id: this.state.insertCourse,
                section_id: 0
            }
            this.addMappingService(payload);
        }else{
            this.setState({page_loading:true});
        for (var i=0;i<this.state.insertSection.length;i++){
            const payload = {
                instructor_id: inst_id,
                course_id: this.state.insertCourse,
                section_id: this.state.insertSection[i].id
            }
            this.addMappingService(payload);
        }
    }


    }

    updateInstructor(hmAccess,LAPAccess){
        //console.log("Editing subject :"  + this.state.instructor_name,this.state.instructorHmAccess,this.state.instructor_id,"      i    ",hmAccess);
        console.log("Inside UpdateInstructor",this.state)
        const payload = {
            instructor_name:this.state.instructor_name,
            instructor_first_name:this.state.instructor_first_name,
            instructor_last_name:this.state.instructor_last_name,
            instructor_id:parseInt(this.state.instructor_id,10),
            instructor_hm_access:hmAccess,
            instructor_login_attempt_access:LAPAccess
        }
        ApiRequestService({
            method: 'post',
            url:  '/updateInstructor',
            data: payload

        })

        .then(res => {
            //console.log("res.data.data.instructor_hm_access",res,"payload ",payload);
        })


    }

    addSubject(){
        this.errorMessageHide();
        this.setState({page_loading:true});
        
        var inst_id =parseInt(this.state.instructor_id,10);
        if(this.state.insertSubject===""){
            NotificationManager.error("Please Choose a Subject", 'Error Message');
            this.setState({page_loading:false});
            return
        }
        const payload = {
            instructor_id: inst_id,
            subject_id: this.state.insertSubject
        }
        console.debug("payload",payload)
        ApiRequestService({
            method: 'post',
            url:  '/addISTMapping',
            data: payload

        }).then(res => {
            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                if(res.data.message.toLowerCase().indexOf("duplicate")>=0){
                    NotificationManager.error("Duplicate entry.Subject already associated with Instructor", 'Error Message', 5000);
                }else{
                    NotificationManager.error(res.data.message, 'Error Message', 5000);
                }
            } else {
                NotificationManager.success('Subject Added', 'Success');
            }
            this.getSubjectData();
            this.hideSubject();
        });
    }



    errorMessageHide(){
        console.log("errorType");
        var tempErrortype = "";

        this.setState({
            errorMessage: tempErrortype,
            errorType:tempErrortype,
        })
    }
    deleteMapping(index){
        this.errorMessageHide();
        console.log("Deleting Mapping index:" + index);
        const payload = {
            id: index
        }
        this.setState({page_loading:true});
        ApiRequestService({
            method: 'post',
            url:  '/deleteICSMapping',
            data: payload
        })
        .then(res => {
            console.log(res);
            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                NotificationManager.error(res.data.message, 'Success');
            } else {
                NotificationManager.success('Section Deleted', 'Success');
            }
            this.prepareData();
        })
    }

    deleteSubjectMapping(index){
        this.errorMessageHide();
        console.log("Deleting Mapping index:", index);
        const payload = {
            id: index
        }
        this.setState({page_loading:true});
        ApiRequestService({
            method: 'post',
            url:  '/deleteISTMapping',
            data: payload
        })
        .then(res => {
            console.log(res);
            this.setState({page_loading:false});
            if(res.data.message !== null && res.data.message !== ""){
                NotificationManager.error(res.data.message, 'Success');
            } else {
                NotificationManager.success('Section Deleted', 'Success');
            }
            this.getSubjectData();
        })
    }

    delete (index) {
        this.errorMessageHide();
        confirmAlert({
          title: 'Are you sure want to delete this Section?',
          message: 'Press Confirm to submit',

          cancelLabel: 'Confirm',
          confirmLabel: 'Cancel',
          onCancel: () => this.deleteMapping(index)
        })
      };

      deleteSubject (index) {
        console.debug("delete subject",index)
        this.errorMessageHide();
        confirmAlert({
          title: 'Are you sure want to delete this Section?',
          message: 'Press Confirm to submit',

          cancelLabel: 'Confirm',
          confirmLabel: 'Cancel',
          onCancel: () => this.deleteSubjectMapping(index)
        })
      };



    loadCourseData(){
        this.setState({dialog_loading:true});
        ApiRequestService({
            method: 'post',
            url: '/getAllCourses'

          })
          .then(res => {
            this.setState({
            courses: res.data.data.course_names,
            insertSection: [],
            dialog_loading: false
          });
          })
    }

    loadSubjectData(){
        this.setState({dialog_loading:true});
        ApiRequestService({
            method: 'post',
            url: '/getUniversitySpecificSubjects'
          })
          .then(res => {
            this.setState({
            subjects: res.data.data.subject_names,

            dialog_loading: false
          });
          console.debug("in load subject ",res.data)
          })
    }

    loadSectionData(course_id){
        this.setState({dialog_loading:true});
        const payload = {
            course_id: course_id

        }
        console.log("Course id : ",payload);
        ApiRequestService({
            method: 'post',
            url: '/getAllSections',
            data: payload
        })
        .then(res => {
            var tempSectionList = [];
          var tempSectionArr = res.data.data.section_names;
          if(tempSectionArr !== null){
            for (var i = 0; i < tempSectionArr.length; i++){
                var tempObj = {};
                tempObj["label"] = tempSectionArr[i].section_name;
                tempObj["id"] = tempSectionArr[i].section_id;
                tempSectionList.push(tempObj);
            }
          }
           this.setState({
            sections: tempSectionList,
            dialog_loading: false
          });

        })
    }

    selectBoxSubjectHandleChange(event) {
                let subject_id = parseInt(event.target.value,10);
                console.debug(event.target,subject_id)
                
                if(isNaN(subject_id)){
                    this.setState({
                        insertSubejct: ''
                    });
                }else{
                    this.setState({
                        insertSubject: subject_id
                    });
                }
              };

    selectBoxCourseHandleChange(event) {

        let course_id = parseInt(event.target.value,10);
        if(isNaN(course_id)){
            this.setState({insertCourse: ''});
            this.setState({disabled:true});
        }else{
        this.setState({insertCourse: course_id,});
        this.setState({disabled:false});
        this.loadSectionData(course_id);
        }
      };

      selectedBadgeClicked(optionsList) {
        var tempInsertSection = [];
        for(var i = 0; i < optionsList.length; i++){
          if(optionsList[i].value ===true){
            var tempInsert = {};
            tempInsert["id"] = optionsList[i].id;
            tempInsertSection.push(tempInsert);
          }
        }
        this.setState({
            sections: optionsList,
            insertSection: tempInsertSection,
         });
      }

      optionClicked(optionsList) {
        this.setState({
            sections: optionsList,
           });
      }


    show = () => {
        this.errorMessageHide();
        this.setState({
            sections:[],
            insertCourse:'',
            visible: true });
        this.loadCourseData();
      };

      showSubject = () => {
        this.errorMessageHide();
        this.setState({
            insertSubject:'',
            visibleSubject: true });
            console.debug("in dhow subject")
            this.loadSubjectData();
           
      };

    hide = () => {
        this.setState({  visible: false,
        addMode: true });
    };
    hideSubject = () => {
        this.setState({  visibleSubject: false,
         });
    };
    instPage(){
        browserHistory.push('/mappings')
    }

    enableInstructorHmAccessOnChange = (e) => {
        //console.debug("enableInstructorHmAccessOnChange ",e)
     // this.setState({instructorHmAccess:true});
     var i = 0; 
      if (e.target.checked){
        this.setState({ instructorHmAccess: 1});
        i=1
      }else{
        this.setState({instructorHmAccess: 0 });
      }
      this.updateInstructor(i,this.state.instructorLoginAttemptPage);
    }    
    
    handleEnableLoginAttemptOnChange = (e) => {
     var i = 0; 
      if (e.target.checked){
        this.setState({ instructorLoginAttemptPage: 1});
        i=1
      }else{
        this.setState({instructorLoginAttemptPage: 0 });
      }
      this.updateInstructor(this.state.instructorHmAccess,i);
    }

    


    render() {

        const selectedOptionsStyles = {
            color: "#FFFFFF",
            backgroundColor: "#bb0000"
          };
          const optionsListStyles = {
            backgroundColor: "#bb0000",
            color: "#FFFFFF"
          };

        let button = null;
        let disabledbutton = null;
        if(this.state.addMode){
            disabledbutton = <button style= {styles.disabledButton} hidden = {!this.state.disabled}>Add</button>
            button = <button style= {styles.addButton} onClick = {this.addMapping} hidden = {this.state.disabled}>Add</button>
        }
        else{
            button = <button style= {styles.addButton} onClick = {this.updateMapping}>Update Mapping</button>
        }
        var cancelButton = <button style= {styles.cancelButton} onClick = {this.hide}>Cancel</button>

        const actions = [];
        actions.push(disabledbutton);
        actions.push(button);
        actions.push(cancelButton);

        //let subButton = null;
        //let subDisabledbutton = null;

        let subButton = <button style= {styles.addButton} onClick = {this.addSubject} >Add</button>
           
        
        var subCancelButton =<button style= {styles.cancelButton} onClick = {this.hideSubject}>Cancel</button>
        

        const SubjectActions = [];
        SubjectActions.push(subButton);
        SubjectActions.push(subCancelButton);
        if(this.state.istmappings !== undefined && this.state.istmappings !== null ){
            var ist =<TableRow>{this.state.istmappings.map((mapping, i) =>
                    
                <Card>
                <TableColumn>
                    {mapping.subject_name}
                </TableColumn>
                <TableColumn>
                        <Button icon tooltipLabel = "Delete" style={{float: 'right',background: "transparent",border: "none"}}
                        onClick = {() =>this.deleteSubject(mapping.id)}>
                            <img src={crossIcon} alt="Delete" />
                        </Button>
                </TableColumn>
                </Card>)}
                </TableRow> 
         }
        return (
           <div >
               <div  style= {instructorStyles.instructorTitle} > {this.props.location.query.instructor_name}
               </div>
               <br/>
               <div style= {{background: '#fff',padding:'10px',paddingLeft:'20px'}}>
                <label for="instrId" style={{fontSize: '20px',paddingRight:'20px'}}>Help menu edit access</label>
                 <Toggle
                    id="instructorHelpMenuAccess"
                    defaultChecked ={ this.state.instructorHmAccess === 1 ? true : false}
                    icons={false}
                    width={100}
                    onChange={this.enableInstructorHmAccessOnChange}
                    checked={this.state.instructorHmAccess === 1 ? true : false}
                />
                </div>
               <div style= {{background: '#fff',padding:'10px',paddingLeft:'20px'}}>
                <label for="instrId" style={{fontSize: '20px',paddingRight:'20px'}}>Login Attempts Page access</label>
                 <Toggle
                    id="instructorHelpMenuAccess"
                    defaultChecked ={ this.state.instructorLoginAttemptPage === 1 ? true : false}
                    icons={false}
                    width={100}
                    onChange={this.handleEnableLoginAttemptOnChange}
                    checked={this.state.instructorLoginAttemptPage === 1 ? true : false}
                />
                </div>
               { <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.visible}
                        onHide={this.hide}
                        actions={actions}
                        title={this.appProperties.schoolMode
                        ?
                            "Add a new Standard and Sections"
                        :
                            "Add a new Course and Sections"}
                        width="600px"
                        contentStyle={{height : "320px"}}
                        titleStyle={{color: '#576271', fontSize : "18px"}}
                        >

                <div style={{float: "left",color:"#576271", paddingLeft:"15px",paddingRight: "10px"}}>

                
                <br></br>
                      <SelectBox 
                      labeltxt={this.appProperties.schoolMode?"Standard":"Course"}
                      columns={this.state.courses} keys={["course_id","course_name"]}
                            style={{...styles.select, width:"500px"}}
                            selectBoxcallBack={this.selectBoxCourseHandleChange} />
                </div>
                <br></br>
                <div style={{float: "left",color:"#576271", paddingLeft:"15px",paddingRight: "10px", width: "550px"}}>
                <label>Section</label><br></br>
                <MultiSelectReact
                          options={this.state.sections}
                          optionClicked={this.optionClicked.bind(this)}
                          selectedBadgeClicked={this.selectedBadgeClicked.bind(this)}
                          selectedOptionsStyles={selectedOptionsStyles}
                          optionsListStyles={optionsListStyles} />

                </div>
                <div>
                    <Loader loading={this.state.dialog_loading} style={{width:"400px",height:"320px"}}/>
                </div>
                </DialogContainer>
              }
              { <DialogContainer
                        id="simple-action-dialog"
                        visible={this.state.visibleSubject}
                        onHide={this.hideSubject}
                        actions={SubjectActions}
                        title="Add a new Subject"
                        width="400px"
                        contentStyle={{height : "320px"}}
                        titleStyle={{color: '#576271', fontSize : "18px"}}
                        >

                <div style={{float: "left",color:"#576271", paddingLeft:"15px",paddingRight: "10px"}}>

                
                <br></br>
                      <SelectBox 
                      labeltxt="Subject"
                      columns={this.state.subjects} keys={["subject_id","subject_name"]}
                            style={styles.select}
                            selectBoxcallBack={this.selectBoxSubjectHandleChange} />
                </div>
                <br></br>
               <div>
                    <Loader loading={this.state.dialog_loading} style={{width:"400px",height:"320px"}}/>
                </div>
                
                </DialogContainer>
              }

            <div style={instructorStyles.instructorTable}>
            <Loader loading={this.state.page_loading}/>
            <Grid>
                <Cell size={6}>
            <ExpansionList >
            <TableRow>
            <TableColumn  style={{color: '#576271', fontSize : "15px"}} >
                {this.appProperties.schoolMode?'Standard List':'Course List'} &nbsp;
                <div style= {styles.floatRight}>
               <Button className="archive-button" primary raised 
                onClick = {this.show}>
                  Add 
               </Button>
              </div>
                </TableColumn>
            </TableRow>
            {this.state.condensedArray.map((mapping, i) =>
            <ExpansionPanel className="md-panel-secondary-label" label={mapping.course_name} footer={null}>
                {mapping.section_name.map((rowData,index) =>
                <TableRow>
                    <TableColumn style={{width:"100px"}}></TableColumn>
                    <TableColumn style={{width:"200px"}}>{rowData}</TableColumn>
                    { (rowData !== 'No Sections')?
                     <TableColumn>
                        <Button icon tooltipLabel = "Delete" style={{float: 'right',background: "transparent",border: "none"}}
                        onClick = {() =>this.delete(mapping.id[index])}>
                            <img src={crossIcon} alt="Delete" />
                        </Button>
                    </TableColumn>:<br></br>
                    }
                </TableRow>
                )}

            </ExpansionPanel>)}
            </ExpansionList>
            </Cell>
            <Cell>
            
                <TableRow>
                    <TableColumn  style={{color: '#576271', fontSize : "15px",width:"100%"}} >Enable editing of question bank subjects &nbsp;
                    
                <Button className="archive-button" primary raised
                    onClick = {this.showSubject}>
                Add
                </Button>
                
                    </TableColumn>
                </TableRow>
                
               
                
                {ist}
                       
            </Cell>
            </Grid>
            </div>
            <NotificationContainer />
            </div>
            

        );
     }
}
